module.exports = __webpack_public_path__ + "6f0a76321d30f3c8120915e57f7bd77e.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/shopee-theme/dist/shopee/element/fonts/element-icons.ttf
// module id = 210
// module chunks = 0